module.exports = __webpack_public_path__ + "files/SPIADI2019 - Article S. capitis.d08fd29fc1b94f4a6ace599eca2b3702.pdf";